// extracted by mini-css-extract-plugin
module.exports = {"list":"Bloglist_list__63i9T"};